import { CustomAppLayout } from '../../../layout';

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: MIT-0
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import React, { useEffect, useMemo, useState } from 'react';
import { useRouter } from '../../../router';
const _preserve = React.version;
//import { useStore } from '../store';
import { useGlobalState } from '../../../../context/GlobalStateContext';


//import { useStoreAdmin } from '../../../../context/useStoreAdmin';

import { Box, Button, FormField, Link, Pagination, SegmentedControl, SpaceBetween, Table, TextFilter } from '@cloudscape-design/components';
import Header from "@cloudscape-design/components/header";
import { mdiDeleteOutline, mdiFileExcel } from '@mdi/js';
import Icon from '@mdi/react';
import Favorites from '../../../../../components/extras/Favorites';
import SelectPaging from '../../../../../components/selects/selectPaging';
import SelectUser from '../../../../../components/selects/selectUser';
import { fetchWithWatch } from '../../../../../hooks/fetchWithWatch';
import { btnIconForm, ItemUser } from '../../../../../resources/types';
import { addNotificationStatus, buildBreadcrumbItems, exportToExcel, formatCurrency, getCookie, getUrlVersion, setData, setLoading, setParameters } from '../../../../commons/functions';

export const Tester = () => {
    const { menu, parameters } = useGlobalState();
    const [users, setUsers] = useState<ItemUser[]>([]);
    const [mUsers, setMUsers] = useState<ItemUser[]>([]);
    const [roll, setRoll] = useState("");
    const [filteringText, setFilteringText] = useState("");
    const { data } = useGlobalState();
    useGlobalState();
    const { navigate } = useRouter();



    const handleMasterUsers = async () => {
        try {
            setLoading(true)
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/admin/users/list',
                    'JWT': getCookie("JWT"),
                    //  
                },
                body: JSON.stringify({
                    isActiveUser: 1,
                    limit: 1000,
                    columns: "idUser, displayName, name, lastName, RUT, email, phone1, age, dateMember",
                    orderBy: "lastName",
                    order: "asc",
                }),
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }
            const dataWeb = await response.json();
            addNotificationStatus(data, setData);
            if (dataWeb.code == 0) {
                setMUsers(dataWeb.users);
            }
        } catch (error: any) {
            //addNotification(`Error de red y/o comunicaciones: ${error.message}`, "error", setData);
        } finally { setLoading(false) }

    }

    const handleUpdateGroup = async () => {
        try {
            console.log({
                idGroup: roll === "VOTINGS.CPV.ROLL" ? 77339 : 77341,
                idUsers: users.map(u => u.idUser)
            })
            setLoading(true)
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/admin/users/groups/update',
                    'JWT': getCookie("JWT"),
                    //  
                },
                body: JSON.stringify({
                    empty: true,
                    idGroup: roll === "VOTINGS.CPV.ROLL" ? 2209069 : 2209070,
                    idUsers: users.map(u => u.idUser)
                }),
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }
            const dataWeb = await response.json();
            addNotificationStatus(dataWeb, setData);

        } catch (error: any) {
            //addNotification(`Error de red y/o comunicaciones: ${error.message}`, "error", setData);
        } finally { setLoading(false) }

    }
    const handleGetUsersFilter = async (body: any) => {
        try {
            setLoading(true)
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/reports/users/list',
                    'JWT': getCookie("JWT"),
                    //  
                },
                body: JSON.stringify(body),
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }
            const dataWeb = await response.json();
            addNotificationStatus(dataWeb, setData);
            if (dataWeb.code == 0) {

                setUsers(dataWeb.users);
            }
        } catch (error: any) {
            //addNotification(`Error de red y/o comunicaciones: ${error.message}`, "error", setData);
        } finally { setLoading(false) }
    }

    const handleGetUser = async (idUser: number) => {
        try {
            setLoading(true)
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/admin/users/get',
                    'JWT': getCookie("JWT"),
                    //  
                },
                body: JSON.stringify({
                    idUser: idUser,
                    columns: "idUser, displayName, name, lastName, RUT, email, phone1, age, dateMember"
                }),
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }
            const dataWeb = await response.json();
            addNotificationStatus(dataWeb, setData);
            if (dataWeb.code == 0) {

                const localUser = dataWeb.user;
                if (localUser) {
                    if (!users.some(u => u.idUser === localUser.idUser)) {
                        setUsers(prev => [...prev, localUser]);
                    }
                }
            }
        } catch (error: any) {
            //addNotification(`Error de red y/o comunicaciones: ${error.message}`, "error", setData);
        } finally { setLoading(false) }

    }

    const sortedUsers = useMemo(() => {
        return [...users].sort((a, b) => {
            const lastNameCompare = a.lastName.localeCompare(b.lastName, 'es', { sensitivity: 'base' });
            if (lastNameCompare !== 0) return lastNameCompare;
            return a.name.localeCompare(b.name, 'es', { sensitivity: 'base' });
        });
    }, [users]); // 👈 Re-runs instantly when setUsers adds a user

    // 2. This is just for your UI display/dropdown
    const filteredUsers = useMemo(() => {
        if (!filteringText || filteringText.trim() === "") return sortedUsers;

        const search = filteringText.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
        return sortedUsers.filter(user => {
            const fullName = `${user.name} ${user.lastName}`.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
            return fullName.includes(search);
        });
    }, [sortedUsers, filteringText]);
    useEffect(() => {

    }, []);

    useEffect(() => {
        if (roll == "VOTINGS.CPV.ROLL") {
            const body = {
                columns: "idUser, displayName, name, lastName, RUT, email, phone1, age, dateMember",
                isActiveUser: 1,
                idCharges: [77339, 77341, 77338, 77246, 77247],
                intersection: 1,
                idUserTypes: [12, 13]
            }
            handleGetUsersFilter(body);
        } else if (roll == "VOTINGS.CPS.ROLL") {

            const body = {
                columns: "idUser, displayName, name, lastName, RUT, email, phone1, age, dateMember",
                isActiveUser: 1,
                idCharges: [77339, 77341],
                intersection: 1,
                idUserTypes: [12, 13]
            }
            handleGetUsersFilter(body);


        }
    }, [roll]);

    const [currentPageIndex, setCurrentPageIndex] = useState(1);
    const paginated = filteredUsers.slice((currentPageIndex - 1) * parameters.pageSize, currentPageIndex * parameters.pageSize);

    return (
        <CustomAppLayout
            toolsHide={true}
            breadcrumbs={
                <BreadcrumbGroup
                    items={buildBreadcrumbItems(menu)}
                    expandAriaLabel="Show path"
                    ariaLabel="Breadcrumbs"
                />
            }
            content={
                <SpaceBetween size="s">

                    <Header variant="h1" actions={<Favorites />} description={`${users.length} usuarios`}>Padrón electoral</Header>
                    <Table
                        filter={
                            <SpaceBetween size="xs" direction="vertical">
                                <SpaceBetween size="xs" direction="horizontal">
                                    <SegmentedControl
                                        onChange={(e) => {
                                            setRoll(e?.detail?.selectedId ?? "")

                                        }}
                                        selectedId={roll}
                                        options={[
                                            { text: 'CPV', id: 'VOTINGS.CPV.ROLL' },
                                            { text: 'CPS', id: 'VOTINGS.CPS.ROLL' },
                                        ]}

                                    />
                                    {roll !== "" && (
                                        <SelectUser value={0}
                                            placeholder={"Agregar usuario"}
                                            onConfirm={(user) => {
                                                if (user) {
                                                    handleGetUser(user.idUser);
                                                }
                                            }} />
                                    )}
                                </SpaceBetween>
                                <SpaceBetween size="xs" direction="horizontal">
                                    <TextFilter filteringText={filteringText} onChange={({ detail }) => setFilteringText(detail.filteringText)}
                                        filteringPlaceholder='Filtrar usuarios'
                                    />

                                    <Button style={{ root: btnIconForm }} disabled={sortedUsers.length === 0} onClick={() => exportToExcel(sortedUsers, `Padrón Electoral ${roll}`, "Usuarios")}><Icon path={mdiFileExcel} size={1} /></Button>

                                    <Button disabled={sortedUsers.length === 0} onClick={() => {
                                        handleUpdateGroup();
                                    }}>Actualizar grupo</Button>

                                </SpaceBetween>

                            </SpaceBetween>
                        }


                        pagination={

                            <SpaceBetween direction="horizontal" size="xs" alignItems="center">
                                {users.length > parameters.pageSize && (
                                    <Pagination
                                        currentPageIndex={currentPageIndex}
                                        pagesCount={Math.ceil(users.length / parameters.pageSize)}
                                        onChange={({ detail }) => setCurrentPageIndex(detail.currentPageIndex)}
                                    />
                                )}

                                {users.length > 0 && users.length > parameters.pageSize && (
                                    <SelectPaging onSelect={(pageSize) => {
                                        setCurrentPageIndex(1);
                                        setParameters({ ...parameters, pageSize: pageSize });
                                    }} />
                                )}
                            </SpaceBetween>
                        }

                        columnDefinitions={[
                            {
                                id: 'name',
                                header: 'Apellido/Nombre',
                                cell: (item) => <FormField label={item.lastName}>{item.name}</FormField>,
                            },
                            {
                                id: 'old',
                                header: 'ANT',
                                cell: (item) => item.membership,
                            },
                            {
                                id: 'balance',
                                header: 'Saldo',
                                cell: (item) => <Box float="right">{formatCurrency(item.balance, "CLP")}</Box>
                            },
                            {
                                id: 'delete',
                                header: '',
                                cell: (item) => <Link onClick={() => {
                                    if (users.some(u => u.idUser === item.idUser)) {
                                        setUsers(prev => prev.filter(u => u.idUser !== item.idUser));
                                    }
                                }}><Icon path={mdiDeleteOutline} size={1} /></Link>
                            },
                        ]}
                        items={paginated}
                    />
                </SpaceBetween>
            }
        />
    )
};
